module.exports = __webpack_public_path__ + "img/company34.33a13993.png";